<div
  cdkDrag
  class="floating-progress-dialog"
  [cdkDragDisabled]="isMinimized"
  [class.floating-progress-dialog--minimized]="isMinimized"
  role="region"
  [attr.aria-label]="progressTitle | translate"
>
  <ng-container *ngIf="!isMinimized; else minimizedView">
    <div cdkDragHandle class="floating-progress-dialog__header">
      <span>{{ progressTitle | translate }}</span>
      <div class="floating-progress-dialog__actions">
        <span
          class="floating-progress-dialog__drag-handle"
          aria-hidden="true"
        ></span>
        <button
          type="button"
          class="floating-progress-dialog__action floating-progress-dialog__close"
          [attr.aria-label]="'DASHBOARD.MINIMIZE_PROGRESS' | translate"
          [title]="'DASHBOARD.MINIMIZE' | translate"
          (pointerdown)="$event.stopPropagation()"
          (click)="minimize()"
        >
          &times;
        </button>
      </div>
    </div>
    <div class="floating-progress-dialog__content" aria-live="polite">
      <div class="floating-progress-dialog__value">
        <span>{{ progressLabel | translate }}</span>
        <span>{{ progressText || progressValue + "%" }}</span>
      </div>
      <p-progressBar
        [value]="progressValue"
        [showValue]="false"
        styleClass="floating-progress-bar"
      ></p-progressBar>
      <div *ngIf="progressSubtext" class="floating-progress-dialog__subtext">
        {{ progressSubtext | translate }}
      </div>
    </div>
  </ng-container>

  <ng-template #minimizedView>
    <button
      type="button"
      class="floating-progress-dialog__restore"
      [attr.aria-label]="'DASHBOARD.MAXIMIZE_PROGRESS' | translate"
      [title]="('DASHBOARD.SHOW_PROGRESS' | translate) + ' (' + progressValue + '%)'"
      (click)="maximize()"
    >
      <img
        src="https://cdn.catexpert.ab-inbev.com/assets/images/icon-info-grey.svg"
        alt=""
        aria-hidden="true"
      />
    </button>
  </ng-template>
</div>
